export enum XenditPaymentChannel {
  AFFIN_FPX = 'Affin Bank',
  AFFIN_FPX_BUSINESS = 'Affin Bank Business',
  AGRO_FPX = 'Agrobank',
  AGRO_FPX_BUSINESS = 'Agrobank Business',
  ALLIANCE_FPX = 'Alliance Bank',
  ALLIANCE_FPX_BUSINESS = 'Alliance Bank Business',
  AMBANK_FPX = 'AmBank',
  AMBANK_FPX_BUSINESS = 'AmBank Business',
  AMBANK_VIRTUAL_ACCOUNT = 'AmBank Virtual Account',
  BNP_FPX_BUSINESS = 'BNP Paribas Business',
  BOC_FPX = 'Bank of China',
  BSN_FPX = 'Bank Simpanan Nasional',
  CARDS = 'Credit / Debit Card',
  CIMB_FPX = 'CIMB Bank',
  CIMB_FPX_BUSINESS = 'CIMB Bank Business',
  CITIBANK_FPX_BUSINESS = 'Citibank Business',
  DEUTSCHE_FPX_BUSINESS = 'Deutsche Bank Business',
  GRABPAY = 'GrabPay',
  HLB_FPX = 'Hong Leong Bank',
  HLB_FPX_BUSINESS = 'Hong Leong Bank Business',
  HSBC_FPX = 'HSBC',
  HSBC_FPX_BUSINESS = 'HSBC Business',
  ISLAM_FPX = 'Bank Islam',
  ISLAM_FPX_BUSINESS = 'Bank Islam Business',
  KFH_FPX = 'Kuwait Finance House',
  KFH_FPX_BUSINESS = 'Kuwait Finance House Business',
  MAYB2E_FPX = 'Maybank2E',
  MAYB2E_FPX_BUSINESS = 'Maybank2E Business',
  MAYB2U_FPX = 'Maybank2U',
  MUAMALAT_FPX = 'Bank Muamalat',
  MUAMALAT_FPX_BUSINESS = 'Bank Muamalat Business',
  OCBC_FPX = 'OCBC Bank',
  OCBC_FPX_BUSINESS = 'OCBC Bank Business',
  PUBLIC_FPX = 'Public Bank',
  PUBLIC_FPX_BUSINESS = 'Public Bank Business',
  RAKYAT_FPX = 'Bank Rakyat',
  RAKYAT_FPX_BUSINESS = 'Bank Rakyat Business',
  RHB_FPX = 'RHB Bank',
  RHB_FPX_BUSINESS = 'RHB Bank Business',
  SCH_FPX = 'Standard Chartered',
  SCH_FPX_BUSINESS = 'Standard Chartered Business',
  SHOPEEPAY = 'ShopeePay',
  TOUCHNGO = "Touch 'n Go",
  UOB_FPX = 'UOB',
  UOB_FPX_BUSINESS = 'UOB Business',
  WECHATPAY = 'WeChat Pay',
}

export const xenditPaymentChannelLabel = (code?: string | null) =>
  code ? XenditPaymentChannel[code as keyof typeof XenditPaymentChannel] || code : ''

export const depositClassLabel = (depositClass?: string | null) => {
  switch (depositClass) {
    case 'SecurityDeposit':
      return 'Security Deposit'
    case 'KeyCardDeposit':
      return 'Key Card Deposit'
    case 'Forfeiture':
      return 'Forfeit'
    default:
      return depositClass || ''
  }
}
